import cn from 'classnames'
import type { HTMLAttributes, Ref } from 'react'
import styles from './block-toolbar.module.css'

interface BlockToolbarProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>
}

export const BlockToolbar = ({ ref, className, ...props }: BlockToolbarProps) => (
  <div ref={ref} {...props} className={cn(styles.toolbar, className)} />
)
